import moment from 'moment';


export default class MomentPlugin {
  /* eslint-disable class-methods-use-this */
  install(Vue) {
    Vue.$moment = moment;
    Vue.prototype.$moment = moment;
  }
  /* eslint-enable class-methods-use-this */
}
